import { notFound } from '@tanstack/react-router';

export function parseReleaseRouteId(id: string): string {
    if (!/^\d+$/.test(id) || BigInt(id) <= 0n) {
        throw notFound();
    }
    return id;
}
